/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, August 20th 2022, 8:13:00 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Chip from "@mui/material/Chip";
import { ProcessDefinition, PROCESSSTATUS } from "lib/schemas";
import { OSCard } from "ui-widgets";
import { StatusUIProperties } from "./ProcessDefinitionUIProperties";

interface ServiceCardProps {
  processDefinition: ProcessDefinition;
  onClick?: () => void;
}

export const ServiceCard = ({ processDefinition, onClick }: ServiceCardProps) => {
  return (
    <OSCard
      cardTitle={
        <>
          <p>{processDefinition.title}</p>
          <div className="os-processDefinitionStatus">
            <Chip
              sx={{
                borderRadius: "50px",
                textTransform: "uppercase",
                backgroundColor: StatusUIProperties?.[processDefinition.status]?.color,
                color: "white",
              }}
              label={PROCESSSTATUS[processDefinition.status]}
              variant="filled"
              size="small"
            />
          </div>
        </>
      }
      imageURL={processDefinition.service_logo}
      onClick={onClick}
      actionText={<>EDIT</>}
    />
  );
};
